<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="400px" persistent>
    <v-card>
      <v-card-title class="title">
        Assign Campaign to the Post
      </v-card-title>
      <v-card-text class="body-2">
        <!-- <p v-if="postData.length">
          Inputted name from Creator: <span class="font-italic">{{postData[0].campaignName}}</span>
        </p> -->
        <v-autocomplete
          :items="campaignList"
          label="Choose Campaigns in IMS:"
          item-value="id"
          item-text="name"
          v-model="selectedCampaignID"
        ></v-autocomplete>
        <table v-if="postData.length" class="post-table">
          <thead>
            <tr>
              <th class="text-left">Influencer</th>
              <th class="text-left">Campaign</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in postData" :key="item._id || index">
              <td class="text-xs-justify pa-1">
                <a
                  :href="'https://www.tiktok.com/@' + item.author.tiktokHandle"
                  target="_blank"
                  v-if="item.author && item.author.tiktokHandle"
                ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.author.tiktokHandle}}</a>
                <a
                  :href="'https://youtube.com/' + item.author.youtubeHandle"
                  target="_blank"
                  v-else-if="item.author && item.author.youtubeHandle"
                ><v-icon>mdi-youtube</v-icon> @{{item.author.youtubeHandle}}</a>
                <a
                  :href="'https://instagram.com/' + item.author.instagramHandle"
                  target="_blank"
                  v-else-if="item.author && item.author.instagramHandle"
                ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.author.instagramHandle}}</a>
                <span v-else>-</span>
              </td>
              <td class="text-xs-left">{{ item.campaignName || '-' }}</td>
            </tr>
          </tbody>
        </table>
        
      </v-card-text>
      <v-card-actions>        
        <v-btn color="red" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="assignCampaign()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import config from '@/config';
import campaignAPIs from '../Campaign/campaignAPIs';
import postAPIs from './postApi';

export default {
  props: {
    value: Boolean,
    posts: Array
  },
  data () {
    return {
      postData: [],
      campaignList: null,
      selectedCampaignID: null
    }
  },
  mounted() {
    this.fetchCampaignList()
  },
  methods: {
    assignCampaign() {
      if (!this.selectedCampaignID) {
        this.$swal({
          title: 'Please choose a campaign',
          type: 'warning'
        })
        return
      }

      let selectedPosts = Array.isArray(this.postData) ? this.postData : []
      Promise.all(selectedPosts.map(post => postAPIs.csAssignCampaign(post._id, this.selectedCampaignID)))
        .then(() => {
          this.$emit('input')
          this.$swal({
            title: 'Saved Changes',
            content: 'Page will reload to apply changes',
            type: 'success'
          }).then(() => this.$emit('success'))
        })
        .catch(err => {
          this.$swal({
            position: 'top-end',
            title: `Can't Save Changes`,
            text: err,
            type: 'error'
          })
        })
    },
    fetchCampaignList() {
      campaignAPIs.getAllCampaignsNoStatus()
        .then(response => {
          let results = []
          response = response.filter(r => r.status === config.campaignStatus.ONGOING || r.status === config.campaignStatus.PAIRING_INFLUENCER)
          response.forEach(element => {
            let campaign = {
              name: element.name,
              id: element.id
            }
            results.push(campaign)
          });
          this.campaignList = results
        })
        .catch(err => {
          console.log('Error:' + err)
        })
    }
  },
  watch: {
    posts(newPostList) {
      if (Array.isArray(newPostList) && newPostList.length > 0) {
        this.postData = newPostList
        this.selectedCampaignID = newPostList[0].campaignID || null
      } else {
        this.postData = []
        this.selectedCampaignID = null
      }
    }
  }
}
</script>

<style scoped>
.post-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
}

.post-table th,
.post-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// AssignCampaignMultipleModal.vue?160cef06